// components/layout/ProgressBar.jsx
import React from 'react';
import { useProgress } from '../../contexts/ProgressContext';
import { Loader2 } from 'lucide-react';

const ProgressBar = () => {
    const { progressState } = useProgress();
    const { isActive, progress, totalSteps, currentOperation } = progressState;

    if (!isActive) return null;

    const percentage = totalSteps > 0 
        ? Math.min(100, Math.floor((progress / totalSteps) * 100))
        : 0;

    return (
        <div className="px-2 py-3 border-t">
            <div className="space-y-2">
                <div className="flex items-center gap-2 text-xs text-gray-600">
                    <Loader2 className="w-3 h-3 animate-spin" />
                    <span className="truncate">{currentOperation}</span>
                </div>
                <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
                    <div 
                        className="h-full bg-blue-600 transition-all duration-300"
                        style={{ width: `${percentage}%` }}
                    />
                </div>
                <div className="text-xs text-right text-gray-500">
                    {percentage}%
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;